import { Typography, Button } from "antd";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import {deleteVehicle, limpModeVehicle, setModalName} from "store/actions";

const { Text, Title } = Typography;

export default function LimpModeForm() {
    const dispatch = useDispatch();
    const { selectedVehicle } = useSelector<AppState, AppState["vehicles"]>(
        (state) => state.vehicles
    );

    const onLimpMode = useCallback(() => {
        dispatch(limpModeVehicle(selectedVehicle?.id || "", selectedVehicle?.isLimpModeOn ? "OFF" : "ON"))
        onCancel();
    }, [dispatch, selectedVehicle?.id]);

    const onCancel = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);

    return (
        <section className="delete-modal">
            <Title level={5}>Vehicle Limp Mode</Title>
            <Text type="secondary">
                Are you sure {selectedVehicle?.isLimpModeOn ? "to turn off limp mode?" : "to turn on limp mode"}
                <strong> “{selectedVehicle?.licensePlate}”</strong> ?
            </Text>
            <div className="action-btn-container">
                <Button className="cancel-btn" onClick={onCancel}>
                    Cancel
                </Button>
                <Button type="primary" danger onClick={onLimpMode}>
                    {selectedVehicle?.isLimpModeOn ? "Turn Limp Mode OFF" : "Turn Limp Mode ON"}
                </Button>
            </div>
        </section>
    );
}
